export default __webpack_public_path__ + "static/media/parcha.6daf4fc4.jpeg";